import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  Table,
  Tbody,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import { useRef, useState } from "react";
import AddLancamentoRow from "./AddLancamento";
import LancamentoItem from "./LancamentoItem";

interface ILancamentoTable {
  itemList: LancamentoFinanceiro[];
  addRowItem: (item: LancamentoFinanceiro) => void;
  editRowItem: (item: LancamentoFinanceiro) => void;
  deleteRow: (item: LancamentoFinanceiro) => void;
  borderColor: string;
  textColor: string;
  user: UsuarioModel;
  selectedCliente: PessoaType;
  tipo: boolean;
}

const LancamentoTable = ({
  addRowItem,
  borderColor,
  deleteRow,
  editRowItem,
  itemList,
  textColor,
  selectedCliente,
  user,
  tipo
}: ILancamentoTable) => {
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const cancelRef = useRef(null);

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };
  const closeError = () => {
    setError(false);
  };


  return (
    <>
      <Table variant="striped" color="gray.500" mb="24px" mt="16px">
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VENCIMENTO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ACRESCIMO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #DESCONTO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TOTAL
              </Flex>
            </Th>


            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TIPO_RECEBIMENTO
              </Flex>
            </Th>



            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OBS/PIX/CÓD.BARRAS
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <AddLancamentoRow
            showError={showError}
            addRowItem={addRowItem}
            textColor={textColor}
            selectedCliente={selectedCliente}
            tipo={tipo}
            user={user}
          />
          {itemList?.map((item, index) => (
            <LancamentoItem
              key={index}
              item={item}
              showError={showError}
              deleteRowItem={deleteRow}
              editRowItem={editRowItem}
            />
          ))}
        </Tbody>
      </Table>
      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default LancamentoTable;
